import { MDBInput } from "mdb-react-ui-kit";

const InputField = ({ type = "text", ...restProps }) => {
    return <MDBInput type={type} {...restProps} size="sm" />;
};

export default InputField;


